import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Provider, useSelector } from 'react-redux';
import Jaws from '@oms/jaws';
import { Link } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { OMSContext, defaultConfig } from '@oms/components-context';
import { theme } from 'styles/theme';

import { BASE_URL, SECURE_BASE_URL } from 'constants/Jaws';

import Routes from './routes';
import configureStore from './store/configureStore';

import { startKeepAlive } from 'components/KeepAlive';
import { selectIsUserLoggedIn } from './state/user/selectors';
import useConfigureJaws from 'utils/configureJaws';

// Uncomment this if you want to use MSW
// if (process.env.NODE_ENV === 'development') {
//   const { worker } = require('./mocks/browser');
//   worker.start();
// }

startKeepAlive();

export const store = configureStore();
const { dispatch } = store;

const useWebSockets =
  (localStorage.getItem('streamingEnabled') || 'true') === 'true';

const componentsContext = {
  ...defaultConfig, // Includes defaults
  Link, // Overrides Link
  transactionsUrl:
    '{+baseUrl}/secure/transactions/{backend}/{userId}/{portfolioId}{/transactionId}{?instrumentId,fromDate,settledStatus,query*}',
};

if (process.env.NODE_ENV === 'development') {
  require('debug').enable('dev');
}
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const elem = document.getElementById('root');
const JawsContext = () => {
  const isLoggedIn = useSelector(selectIsUserLoggedIn);
  const jawsContext = useMemo(() => {
    return {
      instance: new Jaws({
        url: isLoggedIn ? SECURE_BASE_URL : BASE_URL,
        useWebSockets,
      }),
    };
  }, [isLoggedIn]);
  useConfigureJaws(dispatch, useWebSockets);
  return (
    <OMSContext
      config={componentsContext}
      includeGlobalStyles={false}
      includeReset={false}
      theme={theme}
      jaws={jawsContext}
    >
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={null}>
          <Routes />
        </Suspense>
      </QueryClientProvider>
    </OMSContext>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <JawsContext />
    </Provider>
  );
};

ReactDOM.render(<App />, elem);
